export default "__VITE_ASSET__BR$J6VbN__"